import { FormEvent, KeyboardEvent, useRef, useCallback } from 'react'

import useKeyboardShortcuts from '@/hooks/useKeyboardShortcuts'
import { useNavigation } from '@/hooks/useNavigation'
import { SearchIcon, EnterIcon } from '@/icons'

import s from './Search.module.css'

export const Search = () => {
  const { navigateWithParams } = useNavigation()
  const formRef = useRef<HTMLFormElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  useKeyboardShortcuts({
    'meta+k': () => inputRef.current?.focus(),
  })

  const handleSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      const formData = new FormData(e.target as HTMLFormElement)
      const value = formData.get('linkSearch')

      if (value && String(value).trim()) {
        navigateWithParams('/', { q: String(value) })
      } else {
        navigateWithParams('/', {})
      }
    },
    [navigateWithParams]
  )

  const handleEscPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      inputRef.current?.blur()
      formRef.current?.reset()
      navigateWithParams('/', {})
    }
  }

  return (
    <div className={s.container}>
      <span className={s.icon}>{SearchIcon}</span>
      <form ref={formRef} onSubmit={handleSubmit}>
        <input
          name="linkSearch"
          ref={inputRef}
          className={s.search}
          type="text"
          placeholder="Search"
          onKeyUp={handleEscPress}
        />
      </form>
      <span>
        <span className={s.defaultKeys}>
          <span className={s.key}>⌘</span>
          <span className={s.key}>K</span>
        </span>
        <span className={s.activeKeys}>
          <span className={s.key}>{EnterIcon}</span>
        </span>
      </span>
    </div>
  )
}
